(() => {
  if (window.Shopify && window.Shopify.designMode) return;

  const sent = new Set();

  function sendEvent(name, params = {}) {
    const payload = { ...params, event_source: 'crabtalk_shopify' };
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: name, ...payload });
    }
  }

  function scanShippingState() {
    document.querySelectorAll('[data-crabtalk-shipping-state]').forEach((node) => {
      const state = node.getAttribute('data-crabtalk-shipping-state');
      if (state === 'prompt' && !sent.has('free_shipping_prompt_view')) {
        sent.add('free_shipping_prompt_view');
        const remainingCents = Number(node.getAttribute('data-remaining-cents') || 0);
        sendEvent('free_shipping_prompt_view', {
          threshold: 180,
          remaining_value: remainingCents / 100,
          currency: 'SGD',
        });
      }

      if (state === 'unlocked' && !sent.has('free_shipping_unlocked')) {
        sent.add('free_shipping_unlocked');
        sendEvent('free_shipping_unlocked', {
          threshold: 180,
          currency: 'SGD',
        });
      }
    });
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const topup = target.closest('[data-crabtalk-topup]');
    if (topup) {
      sendEvent('topup_click', {
        topup_type: topup.getAttribute('data-crabtalk-topup') || 'unknown',
        product_handle: topup.getAttribute('data-product-handle') || undefined,
        variant_id: topup.getAttribute('data-variant-id') || undefined,
        value: Number(topup.getAttribute('data-value') || 0) || undefined,
        currency: 'SGD',
      });
    }

    const mealGuide = target.closest('[data-crabtalk-meal-guide]');
    if (mealGuide) {
      sendEvent('meal_guide_click', {
        meal_size: mealGuide.getAttribute('data-crabtalk-meal-guide') || 'unknown',
      });
    }

    const homeCta = target.closest('[data-crabtalk-home-cta]');
    if (homeCta) {
      sendEvent('home_sales_cta_click', {
        target: homeCta.getAttribute('data-crabtalk-home-cta') || 'unknown',
      });
    }

    const cookedBundle = target.closest('[data-crabtalk-cooked-bundle]');
    if (cookedBundle) {
      sendEvent('cooked_bundle_click', {
        bundle: cookedBundle.getAttribute('data-crabtalk-cooked-bundle') || 'unknown',
      });
    }

    const crossSell = target.closest('[data-crabtalk-cross-sell]');
    if (crossSell) {
      sendEvent('precart_addon_click', {
        action: crossSell.getAttribute('data-crabtalk-cross-sell') || 'unknown',
        product_handle: crossSell.getAttribute('data-product-handle') || undefined,
        variant_id: crossSell.getAttribute('data-variant-id') || undefined,
        value: Number(crossSell.getAttribute('data-value') || 0) || undefined,
        currency: 'SGD',
      });
    }
  });

  document.addEventListener('change', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    if (target.matches('[data-ct-delivery-time]') && target.value) {
      sendEvent('cooked_delivery_slot_selected', {
        delivery_time: target.value,
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanShippingState, { once: true });
  } else {
    scanShippingState();
  }

  const observer = new MutationObserver(() => scanShippingState());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
